import { Unsubscribe } from 'redux';
import actions from '../../../store/actions';
import Modal from '../../Common/Modal/Modal';
import React from 'react';
import store from '../../../store/store';
import ReportTransferModalState from './ReportTransferModalState';
import { TransferComponent } from '../../../types/transfer/ComponentsForTransfer';
import FormGroup from '../../Common/FormGroup/FormGroup';
import copyObject from '../../../infrastructure/helpers/common/copyObject';
import ComponentTypeTransfer from '../../../types/report/ComponentTypeTransfer';
class ReportTransferModal extends React.Component<any, ReportTransferModalState> {
    private unsubscribe: Unsubscribe | undefined;

    constructor(props: any) {
        super(props);

        this.state = this.getEmptyState();

        this.onOpen = this.onOpen.bind(this);
        this.close = this.close.bind(this);
        this.onConfirmClick = this.onConfirmClick.bind(this);
        this.onNameChange = this.onNameChange.bind(this);
        this.onCommentChange = this.onCommentChange.bind(this);
        this.onSelectedChange = this.onSelectedChange.bind(this);
        this.createContent = this.createContent.bind(this);
        this.onSelectAllClick = this.onSelectAllClick.bind(this);
        this.onClearAllClick = this.onClearAllClick.bind(this);
    }

    componentDidMount(): void {
        this.unsubscribe = store.subscribe(this.onOpen);
    }

    componentWillUnmount(): void {
        (this.unsubscribe as Unsubscribe)();
    }

    getEmptyState() {
        return {
            title: '',
            isOpen: false,
            error: null,
            toTransfer: {
                name: '',
                comment: '',
                refData: [],
                userDefinedFunctions: [],
                dictionaries: [],
                lookups: [],
                cacheKeys: [],
                variables: [],
                filters: [],
                validations: []
            }
        }
    }

    onOpen(): void {
        let state = store.getState();

        if (state.action !== actions.transferChangesModal.open) {
            return;
        }

        let modalState = state.transferChangesModalOpen;

        modalState.toTransfer.name = '';
        modalState.toTransfer.comment = '';

        this.setState(state.transferChangesModalOpen);
    }

    onConfirmClick() {

        if (this.state.toTransfer.name.length === 0 ||
            this.state.toTransfer.comment.length === 0) {

            this.setState({ error: 'Name and Comment are required.' });
            return;
        }

        let transferCount =
            this.state.toTransfer.refData.filter(x => x.isSelected).length +
            this.state.toTransfer.userDefinedFunctions.filter(x => x.isSelected).length +
            this.state.toTransfer.dictionaries.filter(x => x.isSelected).length +
            this.state.toTransfer.lookups.filter(x => x.isSelected).length +
            this.state.toTransfer.cacheKeys.filter(x => x.isSelected).length +
            this.state.toTransfer.variables.filter(x => x.isSelected).length +
            this.state.toTransfer.filters.filter(x => x.isSelected).length +
            this.state.toTransfer.validations.filter(x => x.isSelected).length;

        if (transferCount === 0) {

            this.setState({ error: 'At least one selected component is required.' });
            return;
        }

        let state = copyObject(this.state);

        state.toTransfer.refData = state.toTransfer.refData.filter(x => x.isSelected);
        state.toTransfer.userDefinedFunctions = state.toTransfer.userDefinedFunctions.filter(x => x.isSelected);
        state.toTransfer.dictionaries = state.toTransfer.dictionaries.filter(x => x.isSelected);
        state.toTransfer.lookups = state.toTransfer.lookups.filter(x => x.isSelected);
        state.toTransfer.cacheKeys = state.toTransfer.cacheKeys.filter(x => x.isSelected);
        state.toTransfer.variables = state.toTransfer.variables.filter(x => x.isSelected);
        state.toTransfer.filters = state.toTransfer.filters.filter(x => x.isSelected);
        state.toTransfer.validations = state.toTransfer.validations.filter(x => x.isSelected);

        store.dispatch({ type: actions.transferChangesModal.save, payload: state });

        this.close();
    }

    onSelectedChange(component: TransferComponent, e: React.ChangeEvent<HTMLInputElement>): void {

        let componentCopy = copyObject(component);

        componentCopy.isSelected = e.target.checked;

        let state = copyObject(this.state.toTransfer);

        switch (component.type) {
            case ComponentTypeTransfer.AccuracyValidation: this.changeCollection(componentCopy, state.validations); break;
            case ComponentTypeTransfer.Variable: this.changeCollection(componentCopy, state.variables); break;
            case ComponentTypeTransfer.UserDefinedFunction: this.changeCollection(componentCopy, state.userDefinedFunctions); break;
            case ComponentTypeTransfer.DataSource: this.changeCollection(componentCopy, state.refData); break;
            case ComponentTypeTransfer.Lookup: this.changeCollection(componentCopy, state.lookups); break;
            case ComponentTypeTransfer.Filter: this.changeCollection(componentCopy, state.filters); break;
            case ComponentTypeTransfer.Dictionary: this.changeCollection(componentCopy, state.dictionaries); break;
            case ComponentTypeTransfer.AnnaDsbUpiEnrichmentSelector: this.changeCollection(componentCopy, state.cacheKeys); break;
            case ComponentTypeTransfer.ExchangeRatesSelector: this.changeCollection(componentCopy, state.cacheKeys); break;
            case ComponentTypeTransfer.FCARegulatedEntitiesSelector: this.changeCollection(componentCopy, state.cacheKeys); break;
            case ComponentTypeTransfer.FirdsEsmaInstrumentSelector: this.changeCollection(componentCopy, state.cacheKeys); break;
            case ComponentTypeTransfer.FirdsFcaInstrumentSelector: this.changeCollection(componentCopy, state.cacheKeys); break;
            case ComponentTypeTransfer.IsinSelector: this.changeCollection(componentCopy, state.cacheKeys); break;
            case ComponentTypeTransfer.LeiSelector: this.changeCollection(componentCopy, state.cacheKeys); break;
            case ComponentTypeTransfer.LSESelector: this.changeCollection(componentCopy, state.cacheKeys); break;
            case ComponentTypeTransfer.SymbolSelector: this.changeCollection(componentCopy, state.cacheKeys); break;
            case ComponentTypeTransfer.AnnaDsbUpiSelector: this.changeCollection(componentCopy, state.cacheKeys); break;
        }

        this.setState({ toTransfer: state });
    }

    changeCollection(component: TransferComponent, collection: TransferComponent[]) {

        let item = collection.find(x => x.name === component.name) as TransferComponent;

        item.isSelected = component.isSelected;
    }

    onNameChange(e: React.ChangeEvent<HTMLInputElement>): void {

        let state = this.state.toTransfer;

        state.name = e.target.value;

        this.setState({ toTransfer: state });
    }

    onCommentChange(e: React.ChangeEvent<HTMLTextAreaElement>): void {

        let state = this.state.toTransfer;

        state.comment = e.target.value;

        this.setState({ toTransfer: state });
    }

    getKind(kind: number) {
        switch (kind) {
            case 1: return 'Created';
            case 2: return 'Updated';
            case 3: return 'Deleted';
            default: return '';
        }
    }

    createContent(items: TransferComponent[], title: string) {

        if (items.length === 0) {
            return <></>
        }

        return (
            <>
                <h5 className="mb-3">{title}</h5>
                {
                    items.map((item, index) =>
                        <div className="item" key={index}>
                            <label>
                                <input
                                    type="checkbox"
                                    checked={item.isSelected}
                                    onChange={(e) => this.onSelectedChange(item, e)}
                                />
                                <span>{item.name}</span>
                                <span> - </span>
                                <span>{this.getKind(item.kind)}</span>
                            </label>
                        </div>)
                }
            </>
        )
    }

    onSelectAllClick() {

        let toTransfer = copyObject(this.state.toTransfer);

        this.setSelected(toTransfer.refData, true);
        this.setSelected(toTransfer.userDefinedFunctions, true);
        this.setSelected(toTransfer.dictionaries, true);
        this.setSelected(toTransfer.lookups, true);
        this.setSelected(toTransfer.cacheKeys, true);
        this.setSelected(toTransfer.variables, true);
        this.setSelected(toTransfer.filters, true);
        this.setSelected(toTransfer.validations, true);

        this.setState({ toTransfer: toTransfer });
    }

    onClearAllClick() {

        let toTransfer = copyObject(this.state.toTransfer);

        this.setSelected(toTransfer.refData, false);
        this.setSelected(toTransfer.userDefinedFunctions, false);
        this.setSelected(toTransfer.dictionaries, false);
        this.setSelected(toTransfer.lookups, false);
        this.setSelected(toTransfer.cacheKeys, false);
        this.setSelected(toTransfer.variables, false);
        this.setSelected(toTransfer.filters, false);
        this.setSelected(toTransfer.validations, false);

        this.setState({ toTransfer: toTransfer });
    }

    setSelected(items: TransferComponent[], selected: boolean) {

        items.forEach(x => x.isSelected = selected);
    }

    close(): void {
        this.setState({ isOpen: false });
    }

    render(): JSX.Element {
        const labelClass = 'col-3';
        const contentClass = 'col-9';

        let refData = this.createContent(this.state.toTransfer.refData, 'Date Sources');
        let userDefinedFunctions = this.createContent(this.state.toTransfer.userDefinedFunctions, 'User-Defined Functions');
        let dictionaries = this.createContent(this.state.toTransfer.dictionaries, 'Dictionaries');
        let lookups = this.createContent(this.state.toTransfer.lookups, 'Lookups');
        let cacheKeys = this.createContent(this.state.toTransfer.cacheKeys, 'Cache Keys');
        let variables = this.createContent(this.state.toTransfer.variables, 'Variables');
        let filters = this.createContent(this.state.toTransfer.filters, 'Filters');
        let validations = this.createContent(this.state.toTransfer.validations, 'Validations');

        return (
            <>
                <Modal state={this.state} close={this.close} size="large">

                    {refData}
                    {userDefinedFunctions}
                    {dictionaries}
                    {lookups}
                    {cacheKeys}
                    {variables}
                    {filters}
                    {validations}

                    <div className="mt-3 mb-3">
                        <button type="button" className="btn btn-light" onClick={this.onSelectAllClick}>Select All</button>
                        <button type="button" className="btn btn-light" onClick={this.onClearAllClick}>Clear All</button>
                    </div>

                    <FormGroup label="Name:" labelClassName={labelClass} contentClassName={contentClass}>
                        <input
                            type="text"
                            className="form-control"
                            value={this.state.toTransfer.name}
                            onChange={this.onNameChange} />
                    </FormGroup>

                    <FormGroup label="Comment:" labelClassName={labelClass} contentClassName={contentClass}>
                        <textarea
                            className="form-control"
                            onChange={this.onCommentChange}
                            value={this.state.toTransfer.comment}>
                        </textarea>
                    </FormGroup>

                    <div className="mt-3 mb-3">
                        <button type="button" className="btn cb-btn" onClick={this.onConfirmClick}>Confirm</button>
                    </div>

                </Modal>
            </>
        );
    }
}

export default ReportTransferModal;